import React, {
  cloneElement,
  FormEventHandler,
  FunctionComponent,
  ReactElement,
  useState,
} from 'react';
import {
  OptionButtonInput,
  OptionButtonLabel,
  OptionButtonProps,
  OptionButtonWidth,
  OptionFieldset,
} from '../styles/OptionButton';

type RadioButtonProps = OptionButtonProps;

export const RadioButton: FunctionComponent<RadioButtonProps> = (props) => {
  const {
    children,
    width = OptionButtonWidth.Wide,
    value,
    selected,
    animationEnabled,
    animationIndex,
  } = props;
  const inputId = (children as string).replace(/\s+/g, '');

  return (
    <RadioButtonLabel
      className={selected ? 'selected' : undefined}
      width={width}
      htmlFor={inputId}
      data-test="optionButton"
      animationEnabled={animationEnabled}
      animationIndex={animationIndex}
    >
      <RadioButtonInput
        type="radio"
        name="options"
        defaultChecked={selected}
        value={value}
        id={inputId}
      />
      {children}
    </RadioButtonLabel>
  );
};

type RadioGroupProps = {
  defaultSelected: string | undefined;
  onChange: (changedValue: string) => void;
  children: ReactElement<RadioButtonProps>[];
};

export const RadioGroup: FunctionComponent<RadioGroupProps> = (props) => {
  const { defaultSelected, onChange, children } = props;
  const [selected, setSelected] = useState(defaultSelected);

  function isSelected(option: string) {
    return selected === option;
  }

  const onSelectedChange: FormEventHandler<HTMLFieldSetElement> = (event) => {
    const changedValue = (event.target as HTMLInputElement).value;

    onChange(changedValue);
    setSelected(changedValue);
  };

  return (
    <OptionFieldset onChange={onSelectedChange}>
      {children.map((child: JSX.Element) =>
        cloneElement(child, { selected: isSelected(child.props.value) })
      )}
    </OptionFieldset>
  );
};

const RadioButtonLabel = OptionButtonLabel;
const RadioButtonInput = OptionButtonInput;
